import React, {useEffect, useState} from 'react';
import Footer from '../sectionBlocks/Footer';
import axios from "axios";
import {ProductCard} from "../components/CardList/Card";

const Markets = () => {
  const [data, setData] = useState(null);
  const [nuevaData, setNuevaData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);
  const [newError, setNewError] = useState(null)
  const pathname = window.location.pathname
  const getDataFromRemoteApi = async () => {
    try {

      const response = await axios.get(`https://api.rarible.org/v0.1/items${pathname.slice(8)}`);

      setData(response.data);

      setError(null);
    } catch (err) {
      setError(err.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const getDataFromLocalJson = async () => {

    try {
      const response = await axios.get('../LocalData.json')
      setNuevaData(response.data.items.filter((filterById) => {
        return filterById.id === pathname.slice(9)
      }))
      setNewError(null);
    } catch (err) {
      setNewError(err.message);
      setNuevaData(null);
    } finally {
      setLoading(false);


    }
  }
  useEffect(() => {
    getDataFromLocalJson();
    getDataFromRemoteApi();
  }, []);

  const [x, setX] = useState(0);
  const [img, setImg] = useState("");

  return (
    <>

      {loading && <div>A moment please...</div>}
      {error && (
        <div style={{color: "white"}}> {`There is a problem fetching the data - ${error}`}</div>
      )}
      {data && nuevaData &&
        <>
          <div className="NFTItem" style={{transform: `translateX(${x}%)`}}>
            <div style={{paddingTop: "4rem"}}></div>
            <ProductCard
              uuid={data.id}
              id={data.id}
              name={data.meta.name}
              isImg={!data.meta.content[1]}
              image={nuevaData[0].meta.content[0].url}
              video={nuevaData[0].meta.content[1] ? data.meta.content[1].url : ""}
              openSeaLink={nuevaData[0].OId}
              desc={data.meta.description}
              edition={data.meta.edition}
              sales={data.meta.sales}
              bestSellOrderMakePrice={data.bestSellOrder.makePrice}
              createdAt={data.bestSellOrder.createdAt}
              makeStock={data.bestSellOrder.makeStock}
              totalStock={data.totalStock}
              img={img}
            />
          </div>
        </>
      }
      <Footer/>
    </>
  );
};

export default Markets;